import { ReactNode } from "react";
import { colors } from "constants/colors";
import { StyledText30 } from "styles/Text";
import * as RevealStepCardStyles from "./RevealStepCard.styles";

// 임밍아웃 리포트 스텝 카드
const RevealStepCard = ({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) => {
  return (
    <>
      {title && (
        <RevealStepCardStyles.StyledStepTitleBox $delay={0}>
          <StyledText30 color={colors.white} style={{ whiteSpace: "pre-line" }}>
            {title}
          </StyledText30>
        </RevealStepCardStyles.StyledStepTitleBox>
      )}

      {children}
    </>
  );
};

export default RevealStepCard;
